import { Outlet } from 'react-router-dom'

import { MobileTabBar } from '@/components/layout/MobileTabBar'
import { SiteFooter } from '@/components/layout/SiteFooter'
import { SiteHeader } from '@/components/layout/SiteHeader'
import { SkipLink } from '@/components/layout/SkipLink'

export function AppShell() {
  return (
    <div className="flex min-h-screen flex-col pb-20 md:pb-0">
      <SkipLink />
      <SiteHeader />
      <Outlet />
      <SiteFooter />
      <MobileTabBar />
    </div>
  )
}
